import React from "react";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {Container, Row} from "react-bootstrap";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {mygaSession} from "../../../scripts/myga-session";
import {toCurrency, NassauLog} from "../../../scripts/myga-utils";
import {MM_PAYMENT, MM_PAYMENT_TYPE, MM_PRODUCT, MM_PRODUCT_DTO, MM_PRODUCT_VISUALS} from "../../../scripts/myga-model";
import {productForDTO} from "../../../scripts/product-manager";

class ConfirmEFT extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            errorMessage: ''
        };
    }

    onBackPressed = async () => {
    };

    onNextPressed = async () => {
    };
    
    validate = () => {
        return true;
    };
    
    getPayments = () => {
        let eftPayments = [];
        mygaSession.getCurrentAppProductDTOs().forEach((dto)=>{
            const product = productForDTO(dto);
            dto[MM_PRODUCT_DTO.payments].forEach((payment)=>{
               if (payment[MM_PAYMENT.paymentType]===MM_PAYMENT_TYPE.bankEFT) {
                   eftPayments.push({
                       [MM_PRODUCT.productName]: product[MM_PRODUCT.productName],
                       [MM_PRODUCT_VISUALS.tradeMark]: product[MM_PRODUCT.visuals][MM_PRODUCT_VISUALS.tradeMark],
                       [MM_PRODUCT_VISUALS.surrenderPeriod]: product[MM_PRODUCT.visuals][MM_PRODUCT_VISUALS.surrenderPeriod],
                       [MM_PAYMENT.amount]: payment[MM_PAYMENT.amount]
                   })
               }
            });
        });
        return eftPayments;
    }

    render() {

        return (
            <AppContentWrapper
                validateOnNext={this.validate}
                onBackPressed={this.onBackPressed}
                onNextPressed={this.onNextPressed}
                updatePage={this.props.updatePage}
                errorMessage={this.state.errorMessage}
            >
                <form className={'needs-validation'}
                      ref={(form) => {
                          this.pageForm = form;
                      }}>
                    
                {/* EFT Autorization */}
                 <div className="container page-section disclaimer p-1">
                    <Container id={'confirmEFTContainer'} className={"p-2 font-page-large"}>
                        {
                            this.getPayments().map((payment,index)=>{
                                return (
                                    <Row key={index}>
                                        <div className="col-11 font-weight-bold">
                                            {payment[MM_PRODUCT.productName]}
                                            <sup>{payment[MM_PRODUCT_VISUALS.tradeMark]}</sup>
                                            {` ${payment[MM_PRODUCT_VISUALS.surrenderPeriod]}, EFT: ${toCurrency(parseFloat(payment[MM_PAYMENT.amount]))}`}
                                        </div>
                                    </Row>
                                );
                            })
                        }
                    </Container>

                    <Container className="page-section">
                        <Row className={"p-1"}>
                            <div className="col-11">
                                {MYGAStrings.EFTInfo_BankDraftAcknowledgement}
                            </div>
                        </Row>
                        {/*<Row className="row">*/}
                        {/*    <div className="col-1">*/}
                        {/*        <input id="input-eft-auth"*/}
                        {/*               type="checkbox"*/}
                        {/*               className="page-checkbox"*/}
                        {/*               required*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*    <div className="col-11">*/}
                        {/*        <label id="text-consent-signature">*/}
                        {/*            I agree*/}
                        {/*        </label>*/}
                        {/*    </div>*/}
                        {/*</Row>*/}
                    </Container>


                </div>
                
                </form>

            </AppContentWrapper>


        );

    }
}

export default ConfirmEFT;